import classNames from "classnames";
import { ReactNode, useState } from "react";
import ClickAwayListener from "react-click-away-listener";

const Option = ({
  open,
  close,
  children,
}: {
  open: boolean;
  close: () => void;
  children: ReactNode;
}) => {
  return (
    <div
      className={classNames(
        "absolute left-0 right-0 top-[calc(100%+8px)]",
        "!z-[900] flex w-full flex-col overflow-x-hidden overflow-y-scroll",
        "outline-none focus-within:outline-none focus:outline-none",
      )}
    >
      {children}
    </div>
  );
};

type Props = {
  open: boolean;
  close: () => void;
  setOpen: (val: boolean) => void;
};

export const ManualDropdown = ({
  children,
  menu,
  className = "",
}: {
  children: (props: Props) => ReactNode;
  menu: (props: Props) => ReactNode;
  className?: string;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <ClickAwayListener
      onClickAway={() => {
        setOpen(false);
      }}
    >
      <div className="relative">
        <div
          onClick={() => {
            setOpen(true);
          }}
          className={classNames("w-full text-left", className)}
        >
          {children({
            open,
            close: () => {
              setOpen(false);
            },
            setOpen,
          })}
        </div>

        {open && (
          <Option
            open={open}
            close={() => {
              setOpen(false);
            }}
          >
            {menu({
              open,
              close: () => {
                setOpen(false);
              },
              setOpen,
            })}
          </Option>
        )}
      </div>
    </ClickAwayListener>
  );
};
